module.exports = __webpack_public_path__ + "img/404.3696b6c8.png";